import h from 'virtual-dom/h'

export default function render(settings: any, mutators : any, childRenderers: any, state: any)
{
    let {height, width} = state
        [settings.stateLocations.Window.Base]
        [settings.stateLocations.Window.size];

    let {xPos, yPos} = state
        [settings.stateLocations.Window.Base]
        [settings.stateLocations.Window.position];
        
    let parameters: any = {
        className : settings.classNames.windowClassName,
        style : {
            height,
            width,
        },
        tabIndex: "0",
    };

    if(xPos && yPos){
        if(typeof xPos === "number")
        {
            xPos = xPos + "px";
        }
    
        if(typeof yPos === "number")
        {
            yPos = yPos + "px";
        }
    
        if(typeof height === "number")
        {
            height = height + "px";
        }
    
        if(typeof width === "number")
        {
            width = width + "px";
        }

        parameters.style.top = yPos;
        parameters.style.left = xPos;
    }
    
    mutators.forEach((item) => {
        parameters = item(parameters);
    });
    

    let childNodes : any = [];

    childRenderers.forEach((render: () => any) => {
        childNodes.push(render());
    });

    return h('div', parameters, childNodes);
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window/src/renderers/renderers.ts